import React from "react";
import {t} from "../i18n";
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import {renderField} from "../user/ui/form";
import {Dispatch} from "redux";
import {updateUserDetails} from "../user/UserActions";
import {isValid} from "../user/ui/utils";
import {BrandButton} from "../ui/buttons/buttons";
import {Modal} from "react-bootstrap";
import {MenuCloseButton} from "../ui/navigation/Menu";


interface State {
    isClickedEdit?: boolean;
}

interface Props extends InjectedFormProps{
    value?: string;
    titleText?: string;
    className?: string;
    helpText?: string;
    helpTextForm?: string;
}
const requiredText = (key : string) : string | any => {
    return t("forms.ScreenNameRequired", { label : t(key)});
}
const validateChooseScreenName = (values : { screenName : string})=> {
    let error : any = {};

    if(!isValid(values.screenName,3,25)) {
        error.screenName = requiredText("screenName");
    }
    console.log("Validate = ", error);
    return error;
}

export class ProfileListWithForm extends React.Component<Props, State> {
    constructor(props:Props) {
        super(props);
        this.state = {
            isClickedEdit: false,
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        if(this.props.value != prevProps.value) {
            this.handleClickShowForm();
        }
    }

    handleClickShowForm = () => {
        this.setState({ isClickedEdit: !this.state.isClickedEdit })
    }

    render() {
        const valueText = this.props.value ? this.props.value : t("profile.notSetYet");
        const valueHaveSet = this.props.value != undefined;
        const valueClass = valueHaveSet ? "value haveSet" : "value notSet";
        const props = this.props;
        const { handleSubmit, pristine, reset, submitting, asyncValidating, error } = props;
        return (

                <div className={"row account-page-row"}>
                    <div className={"col-md-6"}>
                        <label>{this.props.titleText}:</label>
                        <span className={"help"}>{this.props.helpText}</span>
                    </div>
                    <div className={"col-md-6 right"}>
                        <span className={"form-value clickable"} onClick={() => this.handleClickShowForm()}>{valueText} <i className={`material-icons`} title={t("profile.tooltip.edit")} >edit</i> </span>
                        {this.state.isClickedEdit && (
                            <Modal show={true} onHide={()=>this.handleClickShowForm()}>
                                <Modal.Header>
                                    <h5>{t("profile.change-screenname")}</h5>
                                    <div className={"menu-close"} onClick={()=> this.handleClickShowForm()}>
                                        <MenuCloseButton />
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                    <form onSubmit={handleSubmit} className={"profile-modal"}>
                                        <Field name="screenName" component={renderField}
                                               type="text" valueText={valueText}
                                               autoFocus={true}
                                               hideHelp={true}
                                        />
                                        <span className={`help`}>{error ? error : this.props.helpTextForm}</span>
                                        {error ? <div className="alert alert-danger">{error}</div> : false}
                                        <BrandButton  onClick={() => this.handleClickShowForm()} type={"button"} className={"btn btn-secondary-popup"}>
                                            { t("common.cancel")}
                                        </BrandButton>
                                        <BrandButton loading={props.submitting} disabled={props.pristine} type={"submit"} className={"btn btn-cta"}>
                                            { t("profile.saveButtonLabel")}
                                        </BrandButton>


                                    </form>
                                </Modal.Body>


                            </Modal>
                        )}
                    </div>
                </div>

        )
    }
}

export default reduxForm({
    form: 'chooseScreenName',
    validate : validateChooseScreenName,
    onSubmit : (req: { screenName : string}, dispatch: Dispatch, props: any) => {
        return dispatch(updateUserDetails({"screenName" : req.screenName}) as any)
    }
})(ProfileListWithForm);